import type { MouseEventHandler } from "react"
import { Button } from "@mui/material"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"

type AddBillReceiverButtonProps = Readonly<{
    onClick: MouseEventHandler<HTMLButtonElement>
    className?: string
}>

export function AddBillReceiverButton({ onClick, className }: AddBillReceiverButtonProps) {
    return (
        <LocalizedStrict id="create-order-bill-receiver-add-button">
            <Button
                type="button"
                variant="text"
                onMouseDown={(e) => e.preventDefault()}
                onClick={onClick}
                className={className}
            >
                + Add bill receiver
            </Button>
        </LocalizedStrict>
    )
}
